'use client';

import React, { CSSProperties, useRef, useState } from 'react';
import * as S from './styles';
import CarouselIndicator from '../../molecules/CarouselIndicador';
import { Skeleton } from '../../atoms/Skeleton';
import { IconeSeta } from '@/components/atoms/Icones/IconeSeta';
import IconButton from '@/components/atoms/IconButton';
import useBreakpoint from '@/hooks/useBreakpoint';
import { registrarEvento } from '@/services/googleAnalytics';
import { PlanoProduto } from '@/types/produto';
import PlanoAssinatura from '@/components/molecules/PlanoAssinatura';

export type CarouselPlanosAssinaturaProps = {
  $planosAssinaturas: Array<PlanoProduto> | null;
  $mostrarControles?: boolean;
  style?: CSSProperties;
  $imageStyle?: CSSProperties;
  $cliquePlano: (index: number) => void;
  $planoSelecionado: number;
};

export default function CarouselPlanosAssinatura(
  props: CarouselPlanosAssinaturaProps,
) {
  const {
    $planosAssinaturas,
    $mostrarControles = true,
    style = {},
    $cliquePlano,
    $planoSelecionado,
  } = props;
  const { breakpoint } = useBreakpoint();

  const [indicePlanoAtual, setIndicePlanoAtual] = useState(0);
  const carouselRef = useRef<HTMLDivElement>(null);
  // eslint-disable-next-line no-undef
  const totalDePlanos = $planosAssinaturas?.length ?? 1;
  const referenciaToqueInicio = useRef<number | null>(null);
  const referenciaToqueFim = useRef<number | null>(null);

  function clicarNaBolinha(indiceBolinha: number) {
    // registrarEvento('home_carrossel_clicou_indice', {
    //   posicao: indiceBolinha + 1,
    // });
    setIndicePlanoAtual(indiceBolinha);
  }

  function irParaProximaPagina() {
    setIndicePlanoAtual((paginaAnterior) =>
      Math.min(paginaAnterior + 1, totalDePlanos - 1),
    );
  }

  function irParaPaginaAnterior() {
    setIndicePlanoAtual((indiceAnterior) => Math.max(0, indiceAnterior - 1));
  }

  const aoIniciarToque = (e: React.TouchEvent<HTMLDivElement>) => {
    referenciaToqueInicio.current = e.touches[0].clientX;
  };

  const aoMoverToque = (e: React.TouchEvent<HTMLDivElement>) => {
    referenciaToqueFim.current = e.touches[0].clientX;
  };

  const aoFinalizarToque = () => {
    if (!referenciaToqueInicio?.current || !referenciaToqueFim?.current) return;

    const diferencaToque =
      referenciaToqueInicio?.current - referenciaToqueFim?.current;

    if (diferencaToque > 50) {
      registrarEvento('home_carrossel_arrastou_proximo', {});
      irParaProximaPagina();
    }
    if (diferencaToque < -50) {
      registrarEvento('home_carrossel_arrastou_anterior', {});
      irParaPaginaAnterior();
    }

    referenciaToqueInicio.current = null;
    referenciaToqueFim.current = null;
  };

  if (!$planosAssinaturas?.length) {
    return <Skeleton style={{ height: 200 }} />;
  }

  return (
    <S.Container
      ref={carouselRef}
      onTouchStart={aoIniciarToque}
      onTouchMove={aoMoverToque}
      onTouchEnd={aoFinalizarToque}
      style={style}
    >
      <S.CarouselWrapper $breakpoint={breakpoint}>
        <S.PlanoTrack $fotoAtual={indicePlanoAtual}>
          {$planosAssinaturas.map((plano, index) => (
            <S.PlanoWrapper
              onClick={() => {
                // registrarEvento('carrossel_clicou_banner', {
                //   posicao: index + 1,
                // });

                $cliquePlano(index);
              }}
              key={index}
            >
              <PlanoAssinatura
                $plano={plano}
                $planoEstaSelecionado={$planoSelecionado === index}
                $breakpoint={breakpoint}
              />
            </S.PlanoWrapper>
          ))}
        </S.PlanoTrack>
      </S.CarouselWrapper>
      <S.ContainerControles>
        {$mostrarControles ? (
          <IconButton
            $size={2}
            $state="default"
            $variant="ghost"
            $color="neutral"
            $highContrast={true}
            $loading={false}
            $Icon={IconeSeta}
            $iconProps={{ direcao: 'esquerda' }}
            $focusRing={false}
            aria-label="Botao Ver Foto Anterior"
            $onClick={() => {
              irParaPaginaAnterior();
              // registrarEvento('home_carrossel_clicou_anterior', {});
            }}
            $mostrarEstilizacaoHover={false}
          />
        ) : null}
        <CarouselIndicator
          $totalImagens={totalDePlanos}
          $currentSlide={indicePlanoAtual}
          $onClickIndicator={clicarNaBolinha}
        />
        {$mostrarControles ? (
          <IconButton
            $size={2}
            $state="default"
            $variant="ghost"
            $color="neutral"
            $highContrast={true}
            $loading={false}
            $Icon={IconeSeta}
            $iconProps={{ direcao: 'direita' }}
            $focusRing={false}
            aria-label="Botao Ver Foto Anterior"
            $onClick={() => {
              irParaProximaPagina();
              // registrarEvento('home_carrossel_clicou_proximo', {});
            }}
            $mostrarEstilizacaoHover={false}
          />
        ) : null}
      </S.ContainerControles>
    </S.Container>
  );
}
